window.addEventListener("load", (e) => {
  let cartCountryEl = document.getElementById("jsCartCountry");
  if (cartCountryEl) {
    $('#jsCartCountry').select2({
      placeholder: "Select a country"
    });
  }
  let cartCountry1El = document.getElementById("jsCartCountry1");
  if (cartCountry1El) {
    $('#jsCartCountry1').select2({
      placeholder: "Select a country"
    });
  }

  let cartStateEl = document.getElementById("jsCartState");
  if (cartStateEl) {
    $('#jsCartState').select2({
      placeholder: "Select a country"
    });
  }
  let cartState1El = document.getElementById("jsCartState1");
  if (cartState1El) {
    $('#jsCartState1').select2({
      placeholder: "Select a country"
    });
  }

  let cartCityEl = document.getElementById("jsCartCity");
  if (cartCityEl) {
    $('#jsCartCity').select2({
      placeholder: "Select a country"
    });
  }
  let cartCity1El = document.getElementById("jsCartCity1");
  if (cartCity1El) {
    $('#jsCartCity1').select2({
      placeholder: "Select a country"
    });
  }

  let cartTelEl = document.querySelector("#jsCartTel");
  if(cartTelEl) {
    window.intlTelInput(cartTelEl, {
      utilsScript: "/assets/lib/intl-tel-input/js/utils.js",
      initialCountry: 'Ca',
    });
  }
});
